<h3 *ngIf="title" class="shops-title">{{ title }}</h3>
<div class="shops-container">
  <div *ngFor="let shop of shops; trackBy: trackById; let i = index" class="shop-tile-container">
    <shop-tile-compact (click)="onShopClick(shop,i)" [shop]="shop" class="hoverable"></shop-tile-compact>
  </div>
</div>
<div *ngIf="hasDivider" class="box-divider"></div>
